import { DARK_THEME_COLORS, IColors, LIGHT_THEME_COLORS, TAssetDoughtnutColors } from '../colors';

const CUSTOM_GREEN = 'rgb(15,178,165)'; // #0FB2A5
const CUSTOM_RED = 'rgb(244,0,0)'; // #F40000

const CUSTOM_DOUGHNUT_COLORS: TAssetDoughtnutColors = [
  'rgba(15, 178, 165, 0.8)',
  'rgba(2, 208, 191, 0.8)',
  'rgba(107, 107, 99, 0.8)',
  'rgba(201, 201, 201, 0.8)',
  'rgba(29, 101, 75, 0.8)',
  'rgba(114, 147, 144, 0.8)'
];

export const HANTEC_DARK_THEME_COLORS: IColors = {
  ...DARK_THEME_COLORS,
  background: [
    'rgb(0,0,0)',
    'rgb(18, 18, 18)',
    'rgb(33, 33, 33)',
    'rgb(82, 85, 99)',
    'rgb(102, 105, 119)',
    'rgb(18,18,18)',
    'rgb(29, 32, 47)'
  ],
  text: ['rgb(234, 236, 239)', 'rgb(201,201,201)', 'rgb(102, 102, 102)', 'rgb(69, 79, 89)', 'rgb(255, 255, 255)'],
  border: ['rgb(33, 33, 33)', 'rgb(33, 33, 33)', 'rgb(51, 51, 51)', 'rgb(102, 102, 102)'],
  error: [CUSTOM_RED, 'rgb(255, 237, 239)'],
  success: [CUSTOM_GREEN, 'rgb(0, 159, 66)', 'rgb(236, 252, 240)'],
  tag: {
    ...DARK_THEME_COLORS.tag,
    success: CUSTOM_GREEN,
    green: CUSTOM_GREEN,
    error: CUSTOM_RED,
    red: CUSTOM_RED
  },
  pnl: {
    ...DARK_THEME_COLORS.pnl,
    green: CUSTOM_GREEN,
    red: CUSTOM_RED,
    idle: 'rgb(102, 102, 102)'
  },
  assetsDoughnut: CUSTOM_DOUGHNUT_COLORS
};

export const HANTEC_LIGHT_THEME_COLORS: IColors = {
  ...LIGHT_THEME_COLORS,
  background: [
    'rgb(255,255,255)',
    'rgb(245, 245, 245)',
    'rgb(245, 245, 245)',
    'rgb(201, 201, 201)',
    'rgb(191, 196, 199)',
    'rgb(245, 245, 245)',
    'rgb(243, 246, 249)'
  ],
  text: ['rgb(18,18,18)', 'rgb(102, 102, 102)', 'rgb(102, 102, 102)', 'rgb(209, 214, 224)', 'rgb(102, 112, 133)'],
  border: ['rgb(245, 245, 245)', 'rgb(201, 201, 201)', 'rgb(51, 51, 51)', 'rgb(18, 18, 18)'],
  error: [CUSTOM_RED, 'rgb(255, 237, 239)'],
  success: [CUSTOM_GREEN, 'rgb(0, 159, 66)', 'rgb(236, 252, 240)'],
  tag: {
    ...LIGHT_THEME_COLORS.tag,
    success: CUSTOM_GREEN,
    green: CUSTOM_GREEN,
    error: CUSTOM_RED,
    red: CUSTOM_RED
  },
  pnl: {
    ...LIGHT_THEME_COLORS.pnl,
    green: CUSTOM_GREEN,
    red: CUSTOM_RED,
    idle: 'rgb(102, 102, 102)'
  },
  assetsDoughnut: CUSTOM_DOUGHNUT_COLORS
};
